export const getFormattedPrice = ({
  locale,
  price,
  currency,
}: {
  locale: string;
  price: number;
  currency: string;
}): string => {
  const numberFormat = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  });

  return numberFormat.format(price);
};
